"use client";

import { CourseEnrollProps } from "../../EnrollButton/types";
import CourseEnrollBox from "./variants/CourseEnrollBox/index";
import CourseEnrollInline from "./variants/CourseEnrollInline";
import CourseEnrollInlineHeader from "./variants/CourseEnrollInlineHeader";

type CourseEnrollMainProps = CourseEnrollProps & {
  variant?: "box" | "inline" | "inlineHeader";
  name?: string;
  location?: string;
  auditTextClassName?: string;
  showOnlyCta?: boolean;
  showEndDate?: boolean;
  auditLinkLocation?: string;
};

export default function CourseEnroll({
  variant = "inline",
  ...props
}: CourseEnrollMainProps) {
  switch (variant) {
    case "box":
      return <CourseEnrollBox {...props} />;
    case "inline":
      return <CourseEnrollInline {...props} />;
    case "inlineHeader":
      return <CourseEnrollInlineHeader {...props} />;
    default:
      return <CourseEnrollInline {...props} />;
  }
}
